import PropTypes from 'prop-types';

const Grid = ({ children }) => {
  return (
    <div className="grid grid-cols-6 gap-x-2 md:gap-x-12 xl:gap-x-[2%] 2xl:gap-x-[4%]">
      {children}
    </div>
  );
};

Grid.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Grid;
